/**
 * Used to determine when to turn a column name into a tooltip.
 */
export const tooltip = {
  maxLength: 25,
  maxWordCount: 3,
};

/**
 * Global DataTable configuration
 */
export const config = {
  // disable row selection
  select: false,
  // setup pagination type
  pagingType: "full_numbers",
  // disable inline search
  searching: false,
  searchDelay: 400,
  // disable initial sorting
  order: [],
  // enable vertical scrolling past a max height
  scrollY: false,
  // enable horizontal scrolling
  scrollX: true,
  // horizontally stretch any tables that don't fill the viewport
  scrollXInner: "100%",
  // allow table to reduce in height when a limited number of rows are shown.
  // http://datatables.net/reference/option/scrollCollapse
  scrollCollapse: true,
  // set number of rows to show on one screen
  lengthMenu: [
    [15, 30, 50, 100],
    ["15", "30", "50", "100"],
  ],
  // turn on and override processing message
  processing: true,
  language: {
    lengthMenu: "Results per page:&nbsp;_MENU_",
    processing: '<div class="loading-indicator-lg"></div>',
    info: "Showing _START_ to _END_ of _TOTAL_ results",
    infoEmpty: "No data was found matching your criteria.",
    emptyTable: "&nbsp;",
    aria: {
      paginate: {
        first: "Go to first page",
        previous: "Go to previous page",
        next: "Go to next page",
        last: "Go to last page",
      },
    },
    paginate: {
      first:
        '<span class="fa fa-fw fa-fast-backward" data-event-category="Paginate" data-event-action="Click" data-event-value="First"></span>',
      previous:
        '<span class="fa fa-fw fa-chevron-left" data-event-category="Paginate" data-event-action="Click" data-event-value="Previous"></span>',
      next: '<span class="fa fa-fw fa-chevron-right" data-event-category="Paginate" data-event-action="Click" data-event-value="Next"></span>',
      last: '<span class="fa fa-fw fa-fast-forward" data-event-category="Paginate" data-event-action="Click" data-event-value="Last"></span>',
    },
  },
  // turn on column reordering
  // http://datatables.net/extensions/colreorder/
  colReorder: {
    // do not visually insert a column until the user drops it
    // http://datatables.net/reference/option/colReorder.realtime
    realtime: false,
  },
  // auto destroys previous DT instance if one exists
  // see https://datatables.net/reference/option/destroy
  destroy: true /*,
	// enable state saving
	// see http://datatables.net/reference/option/stateSave
	stateSave: true,
	stateSaveParams(settings, data) {
		console.info("state", data);
	},
	// in seconds
	// see http://datatables.net/reference/option/stateDuration
	stateDuration: 60 * 60 * 24 * 7
	*/,
};
